import { render, staticRenderFns } from "./home-v2.0.vue?vue&type=template&id=637b45ab&"
import script from "./home-v2.0.vue?vue&type=script&lang=js&"
export * from "./home-v2.0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports